import React, { memo, useState, useEffect } from "react";
import { WebApiCalls } from "../webApiCalls/webApiCalls";
import { formatCurrency } from "./format-currency";
import MyStorage from "./MyStorage";
import Loader from "react-loader-spinner";
import { KMTracking } from '../components/Tracking/KMTracking';
import _ from 'lodash'
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
interface prop {
    item?: any,
    index?: number,
    storeName: string,
    key: number,
    deleteItemCart: any,
    updateCart: any,
    is_loading: boolean,
    onClickItem: any,
    spinning_item: string,
    seeCart:any,
}
function RenderCartItem(props: prop) {
    let { item, storeName, key, deleteItemCart, is_loading, onClickItem, spinning_item ,seeCart} = props
    const [loadingState, setLoadingState] = useState(false);
    const [itemQuantity, setitemQuantity] = useState(0)

    useEffect(() => {
        setitemQuantity(parseInt(item.Quantity))
        let color = "";
        let size = "";
        let BrandName = "";
        item.ItemDetail &&
            item.ItemDetail.CustomFields &&
            item.ItemDetail.CustomFields.length > 0 &&
            item.ItemDetail.CustomFields.map((i, index) => {
            if (i.Name === "Brand") {
              BrandName = i.Values[0];
            }
          });
        item.ItemDetail &&
          item.ItemDetail.Variants &&
          item.ItemDetail.Variants.length > 0 &&
          item.ItemDetail.Variants.map((i, index) => {
            if (i.GroupName === "Size") {
              size = item.Name;
            }
            if (i.GroupName === "Color") {
              color = i.Name;
            }
          });
        let data = {
            "Product id": item.ItemDetail.ID,
            "Product price": item.ItemDetail.Price,
            "Product quantity": item.Quantity,
            "Product name": item.ItemDetail.Name,
            "Brand name": BrandName,
            "Store name": storeName,
            "Product sku": item.ItemDetail.SKU,
            "Product size": size,
            "Product color": color
          }
          if (size === "") {
            _.omit(data,'Product size');
            // delete data["Product size"];
          }
          if (color === "") {
            // delete data["Product color"];
            _.omit(data,'Product color');
          }
          tracker("viewedbagitem", data);

    }, [])
    useEffect(() => {
        if (spinning_item == item.ID) {
            setLoadingState(is_loading)
        }
    }, [is_loading]);
    const tracker = async (eventName, _kmprops) => {
		await KMTracking(eventName, _kmprops)
	}

    const updateItem = async (obj, id) => {
        const storage = new MyStorage()
        let userID = await storage.getUserId();
        let accessToken = await storage.getaccess_token();
        await new WebApiCalls()
            .updateItemCart(userID, accessToken, id, obj)
            .then(async (response) => {
                if (response.Code) {
                } else {
                    props.updateCart();
                }
            });
    };
    // let isTrending = ""
    // let isTrending = item.CustomFields ? item.CustomFields.filter((response => response.Name.includes("trending"))).length > 0 ? item.CustomFields.filter((response => response.Name.includes("trending")))[0].Values[0] : "" : "";;

    let originalPrice = ''
    originalPrice = item.ItemDetail.CustomFields ? item.ItemDetail.CustomFields.filter((response => response.Name.includes("ORIGINAL PRICE (BEFORE DISCOUNT)"))).length > 0 ? item.ItemDetail.CustomFields.filter((response => response.Name.includes("ORIGINAL PRICE (BEFORE DISCOUNT)")))[0].Values[0] : "" : "";;

    if (originalPrice !== '') {
        item.ItemDetail.OriginalPrice = originalPrice
    }
    let isSale = item.ItemDetail.AddOns && item.ItemDetail.AddOns.length > 0 ? item.ItemDetail.OriginalPrice ? true : false :
        item.ItemDetail.StockLimited ? item.ItemDetail.StockQuantity > 0 ? item.ItemDetail.OriginalPrice ? true : false : true : false
    const BrandName = item.ItemDetail.CustomFields
        ? item.ItemDetail.CustomFields.length > 0
            ? item.ItemDetail.CustomFields.filter((item) =>
                item.Name.includes("Brand")
            ).length > 0
                ? item.ItemDetail.CustomFields.filter((item) =>
                    item.Name.includes("Brand")
                )[0].Values[0]
                : ""
            : ""
        : "";
    return (
        <>
            <div className="brand" key={key}>

                {/* info */}
                {/* /info */}

                {/* list */}
                <div className="list">

                    {/* item */}
                    <div className="item" style={{ lineHeight: 1 }}>
                        <div className="thumb" onClick={() => onClickItem(item?.ItemDetail)} ><img src={item?.ItemDetail?.Media[0]?.MediaUrl} alt="" /></div>
                        <div className="details">
                            <div onClick={() => onClickItem(item?.ItemDetail)}>
                            <div className="brand-name">{BrandName.replace(/&amp;/g, "&")}</div>
                            <div className="product-name">{item.ItemDetail.Name}</div>
                            <div className="price">{formatCurrency(item.ItemDetail.Price)}</div>
                            {item?.ItemDetail?.Variants?.length > 0 && item?.ItemDetail?.Variants?.map((itemV, indexV) => {
                                return (
                                    <div key={indexV} className="product-name"
                                        style={{ fontSize: 14 }}
                                    >
                                        {itemV.GroupName ? itemV.GroupName + ": " : ""}{itemV.Name ? itemV.Name : ""}</div>
                                )
                            })}
                            </div>
                            <div className="plusminus">
                                <div className="btn" onClick={async () => {
                                    seeCart()
                                    if (itemQuantity !== 1) {
                                        seeCart()
                                        let obj = {
                                            Quantity: itemQuantity - 1,
                                           
                                        };
                                      
                                        updateItem(obj, item.ID)
                                        await setitemQuantity(itemQuantity - 1)
                                    }
                                }}>-</div>
                                <div className="value">{itemQuantity}</div>
                                <div className="btn" onClick={async () => {
                                      seeCart()
                                    if (item.ItemDetail.StockLimited) {
                                        seeCart()
                                        if (itemQuantity < item.ItemDetail.StockQuantity) {
                                            
                                          
                                            await setitemQuantity(itemQuantity + 1)
                                            let obj = {
                                                Quantity: itemQuantity + 1,
                                            };
                                            

                                            updateItem(obj, item.ID);
                                        }
                                    } else {
                                         seeCart()
                                        await setitemQuantity(itemQuantity + 1)
                                        let obj = {
                                            Quantity: itemQuantity + 1,
                                        };
                                       

                                        updateItem(obj, item.ID);
                                    }
                                }} >+</div>
                            </div>
                        </div>
                        <a onClick={() => {
                            deleteItemCart(item)
                        }} className="remove">{
                                loadingState ?
                                    <Loader
                                        type="TailSpin"
                                        color="white"
                                        height={18}
                                        width={18}
                                    />
                                    :
                                    <img src="images/icon-x.svg" alt="" />}</a>
                    </div>
                </div>
            </div>
        </>
    );
}
export default memo(RenderCartItem);